import React from "react";
import moment from "moment";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Label,
  FormGroup,
} from "reactstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import firebase from "../../../Firebase.js";
import { notification, message, DatePicker, Input as In } from "antd";
import locale from "antd/es/date-picker/locale/es_ES";
import "react-datepicker/dist/react-datepicker.css";

class EditCosturaRecord extends React.Component {
  constructor() {
    super();

    this.ref = firebase.firestore().collection("costura");

    this.state = {
      isOpen2: false,
      color: "",
      fechaEntrada: new Date(),
      fechaSalida: new Date(),
      cantEntrada: "",
      cantSalida: "",
      op: null,
      comercialIndex: null,
      comercialId: null,
      isActive: false,
      entrada: null,
      salida: null,
      cantidadCorte: null,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const {
      ordenPedido,
      colorState,
      doc,
      cantidadCorte,
      entrada,
      salida,
    } = this.props.location.state;
    this.setState({
      entrada: entrada,
      salida: salida,
      cantidadCorte: cantidadCorte,
    });

    function arraymove(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    }

    this.ref
      .doc(String(doc))
      .get()
      .then((ref) => {
        const dataCostura = ref.data();

        let fechaSalida = null;

        const cantEntrada = dataCostura.otros[0].cantEntrada;
        const cantSalida = dataCostura.otros[0].cantSalida;

        const newFI = dataCostura.otros[0].fechaEntrada.split("/");
        arraymove(newFI, 0, 1);
        const fechaEntrada = new Date(newFI.join("/"));
        if (dataCostura.otros[0].fechaSalida) {
          const newFS = dataCostura.otros[0].fechaSalida.split("/");
          arraymove(newFS, 0, 1);
          fechaSalida = new Date(newFS.join("/"));
        }

        this.setState({
          doc,
          fechaEntrada,
          fechaSalida,
          cantEntrada,
          cantSalida,
          color: colorState,
          op: ordenPedido,
        });
      });

    firebase
      .firestore()
      .collection("comercial")
      .where("op", "==", ordenPedido)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.setState({
            comercialIndex: doc
              .data()
              .otros.map((v) => v.color)
              .indexOf(colorState),
            comercialId: doc.id,
          });
        });
      });
  }

  handleClickShowAlert2() {
    this.setState({
      isOpen2: true,
    });

    setTimeout(() => {
      this.setState({
        isOpen2: false,
      });
    }, 1000);
  }

  handleChangeSalida = (date) => {
    this.setState({
      fechaSalida: date,
    });
  };

  handleChangeIngreso = (date) => {
    this.setState({
      fechaEntrada: date,
    });
  };

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  onSubmit2 = (e) => {
    e.preventDefault();

    const {
      fechaEntrada,
      fechaSalida,
      cantSalida,
      cantEntrada,
      doc,
      comercialId,
      cantidadCorte,
    } = this.state;
    if (cantEntrada <= cantidadCorte && cantSalida <= cantEntrada) {
      this.setState({
        isActive: true,
      });
      message.loading("Registrando...", 60);
      const fechaSalidaFormat = moment(fechaSalida).format("DD/MM/YYYY");
      const fechaEntradaFormat = moment(fechaEntrada).format("DD/MM/YYYY");

      try {
        this.ref
          .doc(doc)
          .get()
          .then((res) => {
            const costura = res.data();

            costura.otros[0].cantEntrada = Number(cantEntrada) || "";
            costura.otros[0].cantSalida = Number(cantSalida) || "";
            costura.otros[0].fechaEntrada = fechaEntradaFormat || "";
            costura.otros[0].fechaSalida = fechaSalidaFormat || "";
            costura.otros[0].servicio = "TexCross";
            if (Number(cantSalida) >= costura.cantCorte) {
              costura.entrega = "Completo";
            } else {
              costura.entrega = "Incompleto";
            }

            try {
              firebase
                .firestore()
                .collection("comercial")
                .doc(String(comercialId))
                .get()
                .then((doc) => {
                  let otros = doc.data();

                  otros.otros.map((ids) => {
                    if (ids.color === costura.color) {
                      ids.costura = {
                        cantidadIngresada: Number(cantEntrada) || "",
                        cantidadSalida: Number(cantSalida) || "",
                        fechaIngreso: fechaEntradaFormat || "",
                        fechaSalida: fechaSalidaFormat || "",
                        servicio: "TexCross",
                      };
                    }
                    return ids;
                  });
                  try {
                    firebase
                      .firestore()
                      .collection("comercial")
                      .doc(comercialId)
                      .update(otros);
                  } catch (error) {}
                });
            } catch (error) {
              console.error("Error adding document: ", error.message);
            }

            try {
              firebase
                .firestore()
                .collection("ing")
                .where("op", "==", costura.op)
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    let otros = doc.data().otros;
                    otros.forEach((item) => {
                      if (item.color === costura.color) {
                        item.status = ["Costura"];
                      }
                    });
                    firebase
                      .firestore()
                      .collection("ing")
                      .doc(doc.id)
                      .set({ otros }, { merge: true });
                  });
                });
            } catch (error) {
              console.error(error.message);
            }

            try {
              this.ref
                .doc(String(doc))
                .update(costura)
                .then((_) => {
                  this.setState({
                    fechaSalida: new Date(),
                    cantSalida: "",
                  });
                  message.destroy();
                  const args = {
                    message: "Registro agregado existosamente.",
                    top: 80,
                  };
                  notification.success(args);
                  this.props.history.push("/Costura/Procesos");
                });
            } catch (error) {
              console.error("Error adding document: ", error);
            }
          });
      } catch (error) {
        console.error("Error adding document: ", error);
      }
      setTimeout(() => {
        this.setState({
          isActive: false,
        });
      }, 6000);
    } else {
      this.setState({
        isActive: false,
      });
      const msg = {
        message: `La cantidad Ingresada es mayor que la cantidad Principal ${cantidadCorte}, 
        o la cantidad de salida es mayor a la cantidad Ingresada ${cantEntrada}`,
        top: 80,
      };
      notification.error(msg);
    }
  };

  render() {
    const { cantSalida, op, color, cantEntrada, fechaSalida } = this.state;
    return (
      <div className="content">
        <Row>
          <Col md={6} xs={6}>
            <Card className="card-user">
              <CardHeader style={{ margin: "0 auto" }}>
                <CardTitle>Ingresar Salida</CardTitle>
              </CardHeader>
              <CardBody>
                <form onSubmit={this.onSubmit2}>
                  <FormGroup>
                    <Label style={{ marginLeft: "15px", fontWeight: "bold" }}>
                      ORDEN DE PRODUCCION
                    </Label>
                    <In
                      className="col-md-6 d-block ml-3"
                      value={op}
                      onChange={this.onChange}
                      disabled
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label style={{ marginLeft: "15px", fontWeight: "bold" }}>
                      COLOR
                    </Label>
                    <In
                      className="col-md-9 d-block ml-3"
                      value={color}
                      onChange={this.onChange}
                      disabled
                    />
                  </FormGroup>
                  <FormGroup style={{ marginLeft: "15px", fontWeight: "bold" }}>
                    <Label for="cantIngresada">CANTIDAD INGRESADA</Label>
                    <In
                      type="text"
                      name="cantEntrada"
                      id="cantEntrada"
                      className="col-md-6 d-block"
                      value={cantEntrada}
                      onChange={this.onChange}
                      required
                    />
                  </FormGroup>

                  {this.state.fechaSalida ? (
                    <>
                      <Label style={{ marginLeft: "15px", fontWeight: "bold" }}>
                        FECHA DE ENTREGA:
                      </Label>
                      <div style={{ marginBottom: "20px", marginLeft: "15px" }}>
                        <DatePicker
                          className="col-md-6 d-block"
                          selected={fechaSalida}
                          value={
                            this.state.fechaSalida
                              ? moment(this.state.fechaSalida, "DD/MM/YYYY")
                              : null
                          }
                          onChange={this.handleChangeSalida}
                          format="DD/MM/YYYY"
                          locale={locale}
                          disabled={true}
                        />
                      </div>
                      <FormGroup
                        style={{ marginLeft: "15px", fontWeight: "bold" }}
                      >
                        <Label for="cantSalida">CANTIDAD SALIDA</Label>
                        <In
                          type="text"
                          name="cantSalida"
                          id="cantSalida"
                          className="col-md-6 d-block"
                          value={cantSalida}
                          onChange={this.onChange}
                          required
                        />
                      </FormGroup>
                    </>
                  ) : null}

                  <Row>
                    <div className="update ml-auto mr-auto">
                      <Button
                        color="primary"
                        round
                        style={{ marginTop: "70px" }}
                        type="submit"
                        disabled={this.state.isActive}
                      >
                        Registrar
                      </Button>
                    </div>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default EditCosturaRecord;
